import {Container, Grid, Hidden, Link, Typography, WithStyles, withStyles} from '@material-ui/core';
import {WithTranslation, withTranslation} from 'react-i18next';
import {Link as RouterLink} from 'react-router-dom';

import Map from 'src/Components/Common/FooterBar/Map';
import {footerBarStyles} from 'src/Components/Common/FooterBar/footerBarStyles';
import LinkedInProfileLink from 'src/Components/Common/Links/LinkedInProfileLink';
import XingProfileLink from 'src/Components/Common/Links/XingProfileLink';
import EnumRoutes from 'src/Routes/EnumRoutes';
import {getRoutePathname} from 'src/Routes/getRoutePathname';

const FooterBar = (props: IFooterBarProps) => {
	const linkProps = {language: props.i18n.language};
	const showInn = props.i18n.language === 'ru';

	return (
		<footer className={props.classes.root}>
			<Container maxWidth="lg">
				<Grid container className={props.classes.toolbar}>
					{props.addMap && (
						<Hidden smUp>
							<Map />
						</Hidden>
					)}
					<Hidden xsDown>
						<Grid item className={props.classes.leftSide} xs={6}>
							<Typography variant="body2">
								&copy; {props.t('footer.company-name')},&nbsp;
								{new Date().getFullYear()}
								{showInn && (
									<>
										<br/>
										ИНН: 9200026468
									</>
								)}
							</Typography>
							<Link
								component={RouterLink}
								color="primary"
								underline="always"
								to={getRoutePathname(EnumRoutes.PDP, linkProps)}
								className={props.classes.link}
							>
								{props.t('links.personal-data-policy')}
							</Link>
						</Grid>
						<Grid item className={props.classes.rightSide} xs={6}>
							<Hidden xsDown>
								<Link
									component={RouterLink}
									color="primary"
									underline="always"
									to={getRoutePathname(EnumRoutes.CASES, linkProps)}
									className={props.classes.link}
								>
									{props.t('links.cases')}
								</Link>
								<Link
									component={RouterLink}
									color="primary"
									underline="always"
									to={getRoutePathname(EnumRoutes.JOBS, linkProps)}
									className={props.classes.link}
								>
									{props.t('links.jobs')}
								</Link>
							</Hidden>
							<LinkedInProfileLink iconClassName={props.classes.socialIcon} linkClassName={props.classes.link} />
							<XingProfileLink iconClassName={props.classes.socialIcon} linkClassName={props.classes.xingLink} />
							<Hidden xsDown>
								<Link
									component={RouterLink}
									color="primary"
									underline="always"
									to={getRoutePathname(EnumRoutes.CONTACTS, linkProps)}
									className={props.classes.link}
								>
									{props.t('links.contacts')}
								</Link>
							</Hidden>
						</Grid>
					</Hidden>
					<Hidden smUp>
						<Grid item className={props.classes.rightSide} xs={12}>
							<Link
								component={RouterLink}
								underline="always"
								to={getRoutePathname(EnumRoutes.CASES, linkProps)}
								className={props.classes.link}
							>
								{props.t('links.cases')}
							</Link>
							<Link
								component={RouterLink}
								underline="always"
								to={getRoutePathname(EnumRoutes.JOBS, linkProps)}
								className={props.classes.link}
							>
								{props.t('links.jobs')}
							</Link>
							<Link
								component={RouterLink}
								underline="always"
								to={getRoutePathname(EnumRoutes.CONTACTS, linkProps)}
								className={props.classes.link}
							>
								{props.t('links.contacts')}
							</Link>
						</Grid>
						<Grid item className={props.classes.iconLinks} xs={12}>
							<LinkedInProfileLink iconClassName={props.classes.socialIcon} linkClassName={props.classes.link} />
							<XingProfileLink iconClassName={props.classes.socialIcon} linkClassName={props.classes.xingLink} />
						</Grid>
						<Grid item className={props.classes.leftSide} xs={12}>
							<Typography variant="body2">&copy; &laquo;Aporia&raquo;, {new Date().getFullYear()}</Typography>
							<Link
								component={RouterLink}
								underline="always"
								to={getRoutePathname(EnumRoutes.PDP, linkProps)}
								className={props.classes.pdpLink}
							>
								{props.t('links.personal-data-policy')}
							</Link>
						</Grid>
					</Hidden>
				</Grid>
			</Container>
		</footer>
	);
};

interface IFooterBarProps extends WithStyles, WithTranslation {
	addMap: boolean;
}

export default withStyles(footerBarStyles)(withTranslation('navigation')(FooterBar));
